// extracted by mini-css-extract-plugin
module.exports = {"singleProject":"ProjectView_singleProject__2B-Th","thumbs":"ProjectView_thumbs__3TMpu","fullImg":"ProjectView_fullImg__iHIJf"};